(ns manage.privacy-modal.view
  (:require ["@mui/material/Button$default" :as Button]
            [common.modal.view :refer [modal defmodal]]
            [re-frame.core :as rf]))

(defmodal privacy-modal :privacy-modal []
  [modal {:title "Privacy Settings"
          :footer [:<>
                   [:> Button {:variant "text"
                               :on-click #(rf/dispatch [:modal.privacy/submit false])}
                    "No, I Decline"]
                   [:> Button {:variant "contained"
                               :on-click #(rf/dispatch [:modal.privacy/submit true])}
                    "Yes, I Accept"]]}
   [:p "For the purpose of optimising the Creative Optimizations Platform we would
        like to ask you to allow us to store a user-id and your
        ip-address. This information will be stored and processed by
        Creative Optimizations and 3rd party analytics tools for a maximum period of
        two years."]])
